<template>
  <svg v-show="!error" :width="width" :height="height" fill="#fff">
    <rect fill="#fff" :width="width"  :height="height" :rx="roundedBorder" fill-opacity="1"/>
    <rect x="0" y="4" :fill="color" :width="total" :height="height - 8"  :rx="roundedBorder"/>
  </svg>
</template>

<script>
export default {
  data () {
    return {
      height: 15,
      width: 300,
      color: '#FF274C',
      percent: 0,
      intervalId: null
    }
  },
  props: {
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    roundedBorder () {
      return (this.height / 2).toFixed(2)
    },
    total () {
      return (this.percent > 50 || this.percent === 0) ? (this.percent / 100) * this.width : ((this.percent / 100) * this.width) + this.width * 0.05
    }
  },
  methods: {
    increment () {
      if (this.percent < 100) {
        this.percent = this.percent + 0.5
        window.requestAnimationFrame(this.increment)
      }
    }
  },
  mounted () {
    this.increment()
  }
}
</script>
<style lang="scss" scoped>
@import 'frontendcommon-3/src/scss/config';
.loader{
  position: absolute;
  background-color: $background;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 400;
}
.spinner{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img{
    width: 64px;
    margin-bottom: 20px;
  }
}
.error{
  color: $error;
}
</style>
